export default {
  PLACEMENT: 'LANDING',
  PRODUCT: 'STM'
}
